export default __webpack_public_path__ + "static/media/SWT1180.34I-43199_-25822_0.a982428b.jpg";